import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { changeFormFieldValue, setNewForm } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import ApplePayButton from 'apps/auth/components/applePay/ApplePayButton';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Row } from 'apps/auth/components/common/Layout/Row';
import IframeModal from 'apps/auth/components/common/Modal/IframeModal';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import { FixedBottomPrechequePopUp } from 'apps/auth/components/common/send/popups/FixedBottomPrechequePopUp/FixedBottomPrechequePopUp';
import PreCheckTerms from 'apps/auth/components/common/send/popups/Precheck/PreCheckTerms';
import PreConfirmPopup from 'apps/auth/components/common/send/popups/Precheck/PreConfirmPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import GooglePaySendButton from 'apps/auth/components/googlePay/GooglePaySendButton';
import KlarnaModal from 'apps/auth/components/send/Klarna/KlarnaModal';
import LeanModal from 'apps/auth/components/send/Lean/LeanModal';
import PayPalButtonWrapper from 'apps/auth/components/send/PayPal/PayPalButtonWrapper';
import PlaidCheque from 'apps/auth/components/send/Plaid/PlaidCheque';
import PlaidErrorModal from 'apps/auth/components/send/Plaid/PlaidErrorModal';
import { getPaymentFlow, getRecipientTypeParam, transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { CHANGE_PAYMENT_OPTION_CLICKED, CONFIRM_SEND_SHOWN, FEE_INFO_CLICKED, TRANSFER_SEND_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYMENT_FLOW,
    PAYMENT_METHOD_AMPLITUDE,
    PAYMENT_METHOD_CATEGORY,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    PAYOUT_METHOD_CATEGORY,
    PURPOSE_FROM,
    PURPOSE_TO,
    RECIPIENT_TYPE,
    SCREEN,
    TRANSFER_COUNT,
    TRANSFER_ID,
} from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { DRAFT, NEW, PAYMENT_CONFIRMATION, RECIPIENT, REPEAT } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { LEAN_SDK_SCREEN } from 'apps/auth/constants/ComponentNames';
import {
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH,
    DELIVERY_CASH_UNITELLER,
    DELIVERY_HOME,
    DELIVERY_INTERAC,
    DELIVERY_LIBRE_PAYSEND_LIVE,
    DELIVERY_PEOPLE_TRUST_INTERAC,
    DELIVERY_SWIFT,
    DELIVERY_UPI,
    DELIVERY_VIA_PHONE_NUMBER,
    DELIVERY_WALLET,
    DELIVERY_WECHAT,
    PAYMENT_ACH,
    PAYMENT_APPLE_PAY,
    PAYMENT_EPS,
    PAYMENT_GIROPAY,
    PAYMENT_GOOGLE_PAY,
    PAYMENT_LEAN,
    PAYMENT_MYBANK,
    PAYMENT_PAYPAL,
    PAYMENT_PLAID,
    PAYMENT_SOFORT,
    PAYMENT_KLARNA,
    PAYMENT_TRUSTLY,
    PAYMENT_TINK,
    DELIVERY_SEPA,
    PAYMENT_BLIK,
    PAYMENT_IDEAL,
    PAYMENT_MBWAY,
} from 'apps/auth/constants/Constants';
import { ACCOUNT, COMMENT, SOURCE_CARD_CVV, TO_TRANSFER_PURPOSE, TRANSFER_PURPOSE } from 'apps/auth/constants/fieldsName';
import { PRECHEQUE_FORM, SEND_FORM_NAME } from 'apps/auth/constants/formName';
import {
    AUTH_BONUS_REPEAT,
    AUTH_CANCEL_TRANSACTION,
    AUTH_GA_PAY_STATUS,
    AUTH_PAY_STATUS,
    AUTH_PROFILE_BONUS_WITHDRAW,
    AUTH_SEND_PAY,
    AUTH_SEND_PLAID_ACTION,
    URL_IMAGES_BANKS,
} from 'apps/auth/constants/UrlConstants';
import { PAKISTAN, USA } from 'apps/auth/constants/WellKnownCountries';
import { apiFetchData, changeBrowserUrlWithOutReload, fetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { addScript } from 'apps/auth/helpers/DOM';
import { getFormattedPhoneNumber, resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';
import { useQuery } from 'apps/auth/hooks/useQuery';
import { ApiService } from 'apps/auth/services/apiService';

import ConfirmTransactionDetails from './ConfirmTransactionDetails';
import PaymentSmsConfirmModal from './PaymentSmsConfirmModal';
import PostPrechequeCvvPopup from './PostPrechequeCvvPopup';
import PreCheckPoweredBy from './PreCheckPoweredBy';

const iconNameObj = {
    [DELIVERY_BANK_CARD]: 'card-48',
    [DELIVERY_VIA_PHONE_NUMBER]: 'mobile-48',
    [DELIVERY_BANK_ACCOUNT]: 'bank-48',
    [DELIVERY_SEPA]: 'bank-48',
    [DELIVERY_CASH]: 'cash-stack-48',
    [DELIVERY_CASH_UNITELLER]: 'cash-stack-48',
    [DELIVERY_HOME]: 'cash-stack-48',
    [DELIVERY_UPI]: 'upi-48',
    [DELIVERY_WALLET]: 'wallet-48',
    [DELIVERY_INTERAC]: 'interac-48',
    [DELIVERY_PEOPLE_TRUST_INTERAC]: 'bank-48',
    [DELIVERY_SWIFT]: 'globe-48',
    [DELIVERY_LIBRE_PAYSEND_LIVE]: 'person-48',
};
const imgObj = {
    [PAYMENT_TRUSTLY]: {
        img: 'trustly-logo',
        alt: 'Trustly',
    },
    [PAYMENT_TINK]: {
        img: 'tink-logo',
        alt: 'Tink',
    },
    [PAYMENT_SOFORT]: {
        img: 'sofort-logo',
        alt: 'Sofort',
    },
    [PAYMENT_KLARNA]: {
        img: 'klarna-logo',
        alt: 'Klarna',
    },
    [PAYMENT_GIROPAY]: {
        img: 'giropay-logo',
        alt: 'Giropay',
    },
    [PAYMENT_MYBANK]: {
        img: 'mybank-logo',
        alt: 'MyBank',
    },
    [PAYMENT_LEAN]: {
        img: 'lean-logo',
        alt: 'Lean',
    },
    [PAYMENT_PLAID]: {
        img: 'plaid-logo',
        alt: 'Plaid',
    },
    [PAYMENT_EPS]: {
        img: 'eps-logo',
        alt: 'EPS',
    },
    [PAYMENT_BLIK]: {
        img: 'blik-logo',
        alt: 'Blik',
    },
    [PAYMENT_IDEAL]: {
        img: 'ideal-logo',
        alt: 'Ideal',
    },
    [PAYMENT_MBWAY]: {
        img: 'mbway-logo',
        alt: 'MBWay',
    },
};

const PreCheckPopup = (props) => {
    const messages = usePageMessages();
    const { countryId: userCountry } = useAuth();
    const { fields } = useForm(SEND_FORM_NAME);
    const {
        precheck,
        payment_form: paymentForm,
        dcSources,
        toCountry,
        fromCountry,
        repeatDraft,
        pocket,
        userComeFromSend,
        showCVVPopUp,
        showBeforeCvvDisclaimer,
        typeOfTransfer,
        sendFlowV3,
        payoutCategory,
        paymentCategory,
    } = useExtra();
    const query = useQuery();
    const recipientType = typeOfTransfer || query.get('type');
    const toTransferPurpose = fields[TO_TRANSFER_PURPOSE]?.value;
    const fromTransferPurpose = fields[TRANSFER_PURPOSE]?.value;

    const accountValue = fields[ACCOUNT]?.value;
    const comment = fields[COMMENT]?.value;
    const sourceFundingId = fields.fromPrvId?.value;
    const deliveryMethodId = fields.toPrvId?.value;

    const amplitudeSendingMethod = transactionMethods[precheck.paymentMethod];
    const amplitudeDeliveryMethod = transactionMethods[precheck.deliveryMethod];
    const amplitudeEventParams = {
        [PAYOUT_COUNTRY]: toCountry?.nameEn,
        [PAYMENT_COUNTRY]: fromCountry?.nameEn,
        [PAYOUT_METHOD]: amplitudeDeliveryMethod,
        [PAYMENT_METHOD_AMPLITUDE]: amplitudeSendingMethod,
        [PAYOUT_METHOD_CATEGORY]: payoutCategory,
        [PAYMENT_METHOD_CATEGORY]: paymentCategory,
        [PAYOUT_CURRENCY]: precheck.amountToCurrency,
        [PAYMENT_CURRENCY]: precheck.amountFromCurrency,
        [TRANSFER_ID]: precheck?.id,
    };
    const isLibre = precheck.deliveryMethod === DELIVERY_LIBRE_PAYSEND_LIVE;
    const fromLean = paymentForm?.paymentSourceFromMethod === PAYMENT_LEAN;
    const fromPlaid = paymentForm?.paymentSourceFromMethod === PAYMENT_PLAID;
    const fromTrustly = paymentForm?.paymentSourceFromMethod === PAYMENT_TRUSTLY;
    const fromTink = paymentForm?.paymentSourceFromMethod === PAYMENT_TINK;
    const fromSofort = paymentForm?.paymentSourceFromMethod === PAYMENT_SOFORT;
    const fromKlarna = paymentForm?.paymentSourceFromMethod === PAYMENT_KLARNA;
    const fromACH = paymentForm?.paymentSourceFromMethod === PAYMENT_ACH;
    const fromGooglePay = paymentForm?.paymentSourceFromMethod === PAYMENT_GOOGLE_PAY;
    const fromApplePay = paymentForm?.paymentSourceFromMethod === PAYMENT_APPLE_PAY;
    const fromGiropay = paymentForm?.paymentSourceFromMethod === PAYMENT_GIROPAY;
    const fromMyBank = paymentForm?.paymentSourceFromMethod === PAYMENT_MYBANK;
    const fromEps = paymentForm?.paymentSourceFromMethod === PAYMENT_EPS;
    const fromPayPal = paymentForm?.paymentSourceFromMethod === PAYMENT_PAYPAL;
    const fromBlik = paymentForm?.paymentSourceFromMethod === PAYMENT_BLIK;
    const fromIdeal = paymentForm?.paymentSourceFromMethod === PAYMENT_IDEAL;
    const fromMBWay = paymentForm?.paymentSourceFromMethod === PAYMENT_MBWAY;
    const isLean = fromLean && precheck?.extra?.leanAppToken && precheck.extra?.leanCustomerId && precheck.extra?.lean_intent_id;
    const withoutIconName = precheck.toBankAlias || precheck.deliveryMethod === DELIVERY_ALIPAY || precheck.deliveryMethod === DELIVERY_WECHAT;
    const iconName = iconNameObj[precheck.deliveryMethod] ?? 'card-48';
    const formattedPhoneNumber = isLibre ? `+${getFormattedPhoneNumber(accountValue, toCountry.id)}` : '';
    const pocketId = pocket?.id;
    const transferCount = __isBrowser__ ? localStorage.getItem('transferCount') : null;

    useEffect(() => {
        const isRepeat = !!paymentForm?.repeatPaymentId;
        amplitude.getInstance().logEvent(CONFIRM_SEND_SHOWN, {
            [PAYMENT_FLOW]: getPaymentFlow(repeatDraft, isRepeat, userComeFromSend),
            [RECIPIENT_TYPE]: getRecipientTypeParam(recipientType),
            [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
            ...amplitudeEventParams,
        });
        return () => {
            props.changeFormFieldValue(props.formName, null, SOURCE_CARD_CVV);
        };
    }, []);

    useEffect(() => {
        if (fromPlaid) {
            addScript('https://cdn.plaid.com/link/v2/stable/link-initialize.js');
        }
    }, [fromPlaid]);

    const amplitudeSendClick = () => {
        const isRepeat = !!paymentForm?.repeatPaymentId;
        amplitude.getInstance().logEvent(TRANSFER_SEND_CLICKED, {
            [PURPOSE_TO]: toTransferPurpose,
            [PURPOSE_FROM]: fromTransferPurpose,
            [PAYMENT_FLOW]: getPaymentFlow(repeatDraft, isRepeat, userComeFromSend),
            [RECIPIENT_TYPE]: getRecipientTypeParam(recipientType),
            [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
            ...amplitudeEventParams,
        });
    };

    const sendAmplitudeFlowV3Event = (eventName) => {
        if (sendFlowV3) {
            const paymentParams = {
                [PAYMENT_COUNTRY]: fromCountry?.nameEn,
                [PAYMENT_CURRENCY]: precheck.amountFromCurrency,
                [PAYMENT_METHOD_AMPLITUDE]: amplitudeSendingMethod,
            };
            let eventParams = paymentParams;

            if (eventName === FEE_INFO_CLICKED) {
                eventParams = {
                    ...paymentParams,
                    [SCREEN]: PAYMENT_CONFIRMATION,
                    [PAYOUT_COUNTRY]: toCountry?.nameEn,
                    [PAYOUT_CURRENCY]: precheck.amountToCurrency,
                    [PAYOUT_METHOD]: amplitudeDeliveryMethod,
                };
            }
            amplitude.getInstance().logEvent(eventName, eventParams);
        }
    };

    const sendClick = () => {
        amplitudeSendClick();
        if (repeatDraft && paymentForm.repeatPaymentId) {
            apiFetchData(AUTH_CANCEL_TRANSACTION + '?paymentId=' + paymentForm.repeatPaymentId + '&isDraft=true').catch((error) => {
                logWarn(error);
            });
        }
    };

    const setPaymentParam = () => {
        const isRepeat = !!paymentForm?.repeatPaymentId;
        if (userComeFromSend) {
            return RECIPIENT;
        } else if (repeatDraft) {
            return DRAFT;
        } else if (isRepeat) {
            return REPEAT;
        } else {
            return NEW;
        }
    };

    const onConfirmButtonClick = () => {
        if (showBeforeCvvDisclaimer && showCVVPopUp) {
            props.popupRef?.current?.close();
            props.modalRef.current?.open(
                <ModalComponent isVerticalCentered canCloseModal={false}>
                    <InfoPage
                        insideModalComponent
                        iconName="card-alert-80"
                        iconColor="primary"
                        headerText={
                            <>
                                <span>{messages.headerPurpleBlock} </span>
                                {messages.headerText}
                            </>
                        }
                        secondaryText={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={messages.secondaryText} />}
                        primaryButtonCaption={messages.gotIt}
                        primaryButtonType="button"
                        primaryButtonOnClick={() => showCvvPopUp(true)}
                    />
                </ModalComponent>,
            );
        } else if (showCVVPopUp) {
            showCvvPopUp();
        } else {
            payAgree();
        }
    };

    const showCvvPopUp = (closeModal = false) => {
        amplitudeSendClick();
        if (closeModal) {
            props.modalRef.current?.close();
        }
        let cards = dcSources?.CARD;
        const card = cards.find(({ code }) => code === paymentForm.sourceCodeFrom);

        let cvv = getField(SOURCE_CARD_CVV, '', '', true, false, messages.cvvPlaceholder, 'text');
        cvv.comment = messages.cvvComment;
        const paymentId = getField('id', precheck.id);
        const acceptedPayment = getField('acceptedPayment', true);

        props
            .setNewForm(
                PRECHEQUE_FORM,
                {
                    [cvv.name]: cvv,
                    [paymentId.name]: paymentId,
                    [acceptedPayment.name]: acceptedPayment,
                },
                AUTH_SEND_PAY,
            )
            .then(() => {
                props.popupRef?.current?.open(
                    <PostPrechequeCvvPopup
                        formName={PRECHEQUE_FORM}
                        title={resolveArguments(messages.cvvPopupTitle, `${card?.alias} ·· ${card?.description}`)}
                        popupRef={props.popupRef}
                        onClose={closeHandler}
                        getPaymentFlow={getPaymentFlow}
                    />,
                );
            });
    };

    const payAgree = (e) => {
        e?.preventDefault?.();
        props.toggleSpinner(true);
        props.popupRef?.current?.close();
        sendClick();
        const fields = {};
        // eslint-disable-next-line no-undef
        fields.id = getField('id', precheck.id);
        fields.acceptedPayment = getField('acceptedPayment', true);
        if (isLibre) {
            fields.comment = getField('comment', comment);
        }
        initApiRequest(fields);
    };

    const initApiRequest = (fields) => {
        apiFetchData('/auth/send/pay.action', fields)
            .then((json) => {
                if (json?.messageBodyMessages) {
                    updateMessages(json.messageBodyMessages);
                }
                if (json.messages) {
                    props.updatePageMessages(json.messages);
                }
                if (json.extra?.iframeRedirectUrl) {
                    if (fromTrustly) {
                        openIframeModal(json.extra?.iframeRedirectUrl);
                        return;
                    }
                    if (fromKlarna) {
                        // const link = 'https://storage.googleapis.com/network-team-public-bucket/klarna-sdk-test-close-window-4.html';
                        props.modalRef.current?.open(<KlarnaModal modalRef={props.modalRef} iframeLink={json.extra?.iframeRedirectUrl} />);
                        return;
                    }

                    const currentUrl = window.location.href;
                    const paramToAdd = 'toScreen=paymentMethods';
                    const separator = currentUrl.includes('?') ? '&' : '?';
                    const backUrl = currentUrl + separator + paramToAdd;
                    const { fields: paymentMethodFields, extra: paymentMethodExtra } = props.paymentMethodState?.current || {};
                    changeBrowserUrlWithOutReload(backUrl, { paymentMethodFields, paymentMethodExtra });
                    window.location.href = json.extra?.iframeRedirectUrl;
                    return;
                } else if (json.redirectTo) {
                    window.location.href = json.redirectTo;
                    return;
                } else if (json.extra?.smsConfirmation) {
                    return props
                        .toggleSpinner(false)
                        .then(() =>
                            props.toggleModal(
                                true,
                                <PaymentSmsConfirmModal
                                    customTitle={json.messages?.paymentSmsConfirmation}
                                    enterSmsTitle={json.messages?.enterSmsTitle}
                                    smsConfirmation={json.extra.smsConfirmation}
                                    smsConfirmationAutoCloseInfo={json.messages?.smsConfirmationAutoCloseInfo}
                                    redirectUrl={`${AUTH_PAY_STATUS}?id=${json.extra.smsConfirmation.objectId}`}
                                />,
                                false,
                            ),
                        );
                } else if (isLean) {
                    props.modalRef?.current?.open(
                        <LeanModal
                            href={`${AUTH_PAY_STATUS}?id=${json?.status?.id}`}
                            bankId={precheck?.extra?.bank_id}
                            leanPaymentIntendId={precheck?.extra?.lean_intent_id}
                            currentScreen={LEAN_SDK_SCREEN}
                            modalRef={props.modalRef}
                        />,
                    );
                } else if (json.status) {
                    window.location.href = pocketId
                        ? `${AUTH_GA_PAY_STATUS}?id=${json.status.id}&pocketId=${pocketId}`
                        : `${AUTH_PAY_STATUS}?id=${json.status.id}`;
                    return;
                } else if (json.bankAccountStatus?.plaidToken) {
                    openPlaid(json.bankAccountStatus);
                }
                props.toggleSpinner(false);
            })
            .catch((e) => {
                logWarn(e);
                props.toggleSpinner(false);
            });

        const paymentParam = setPaymentParam();
        sessionStorage?.setItem(precheck?.id, paymentParam);
    };

    const openPlaid = (bankStatusPlaid) => {
        const linkToken = bankStatusPlaid.plaidToken;
        const bankName = bankStatusPlaid.plaidBankName;
        if (linkToken && Plaid) {
            const handler = Plaid.create({
                token: linkToken,
                onSuccess: function (public_token) {
                    props.toggleSpinner(true);
                    const url = `${AUTH_SEND_PLAID_ACTION}?fromPrvId=${paymentForm.fromPrvId}&paymentId=${precheck.id}&publicToken=${public_token}`;
                    fetchData(url);
                    props.popupRef?.current?.close();
                    props.toggleModal(true, <PlaidCheque bankName={bankName} />);
                    props.toggleSpinner(false);
                },
                onEvent: function (eventName, metadata) {
                    if (eventName === 'ERROR' || eventName === 'EXIT') {
                        props.toggleSpinner(true);
                        props.popupRef?.current?.close();
                        props.toggleModal(true, <PlaidErrorModal errorText={metadata?.error_message || messages.paymentFailed} />);
                        props.toggleSpinner(false);
                    }
                },
            });
            handler.open();
        }
    };

    const closeHandler = () => {
        props.popupRef?.current?.open(<PreCheckPopup popupRef={props.popupRef} {...props} />);
    };

    const preConfirm = () => {
        props.popupRef?.current?.open(<PreConfirmPopup messages={messages} onClose={closeHandler} payAgree={payAgree} popupRef={props.popupRef} />);
        sendClick();
    };

    const openIframeModal = (iframeRedirectUrl) => {
        props.popupRef?.current?.close();
        props.modalRef.current?.open(<IframeModal iframeLink={iframeRedirectUrl} modalRef={props.modalRef} />);
        props.toggleSpinner(false);
    };

    const getAvatar = (precheque_form) => {
        if (precheque_form.deliveryMethod === DELIVERY_WECHAT) {
            return `${URL_IMAGES_BANKS}/wechat.png`;
        }

        if (precheque_form.deliveryMethod === DELIVERY_ALIPAY) {
            return `${URL_IMAGES_BANKS}/alipay-big.png`;
        }

        if (precheque_form.toBankAlias) {
            return `${URL_IMAGES_BANKS}/${precheque_form.toBankAlias}.png`;
        }

        return null;
    };

    const getPrecheckTitle = () => {
        if (isLibre) {
            return resolveArguments(messages.chequeBlockToInterac, formattedPhoneNumber);
        } else {
            return precheck.nameTo;
        }
    };

    return (
        <ComplexPopup popupRef={props.popupRef} withoutButton textCenter withoutCloseButton hasBottomPanel hasPseudoTable>
            {userCountry === USA && !isLibre && (
                <Text variant="div" size="secondary" indent="adaptive-24-32">
                    {messages.chequeUsaNotReceipt}
                </Text>
            )}
            <Row indent="adaptive-16-24">
                <DiskBadge
                    iconName={withoutIconName ? null : toCountry.id === PAKISTAN ? 'mobile' : iconName}
                    src={getAvatar(precheck)}
                    diskSize="large"
                    flagName={!isLibre ? toLowerCase(precheck.toBankCountryCode) : null}
                />
            </Row>
            <Text variant="div" indent="4px" ellipsis>
                {getPrecheckTitle()}
            </Text>
            <Text variant="div" size="header" indent={isLibre ? 'adaptive-16-24' : 'adaptive-32-48'}>
                {`${precheck.formatedAmountFrom} `}
                <Text size="header" smallCaps>
                    {toLowerCase(precheck.amountFromCurrency)}
                </Text>
                {' → '}
                {`${precheck.formatedAmountTo} `}
                <Text size="header" smallCaps>
                    {toLowerCase(precheck.amountToCurrency)}
                </Text>
            </Text>
            {isLibre && (
                <Row indent="adaptive-24-32">
                    <InputText formName={SEND_FORM_NAME} field={fields.comment} isNewInput isCenteredInput />
                </Row>
            )}

            <ConfirmTransactionDetails
                isLibre={isLibre}
                formName={SEND_FORM_NAME}
                popupRef={props.popupRef}
                modalRef={props.modalRef}
                closeHandlerForPopup={closeHandler}
                recipientType={recipientType}
                sendEvent={sendAmplitudeFlowV3Event}
            />

            {!window.location?.pathname.includes(AUTH_PROFILE_BONUS_WITHDRAW) && !window.location?.pathname.includes(AUTH_BONUS_REPEAT) && (
                <Row indent="16px">
                    <PopupButton
                        iconName="arrow-exchange"
                        onClick={() => {
                            sendAmplitudeFlowV3Event(CHANGE_PAYMENT_OPTION_CLICKED);
                            ApiService.fetchWithoutSpinner(AUTH_CANCEL_TRANSACTION + '?paymentId=' + precheck.id);
                            props.changePaymentMethod?.();
                            props.popupRef?.current?.close();
                        }}
                        text={messages.changePaymentOption}
                        title={messages.changePaymentOption}
                        type="button"
                        isCentered
                    />
                </Row>
            )}

            <PreCheckTerms precheck={precheck} userCountry={userCountry} toCountry={toCountry} />
            {(fromTrustly ||
                fromSofort ||
                fromGiropay ||
                fromMyBank ||
                fromLean ||
                fromPlaid ||
                fromEps ||
                fromKlarna ||
                fromTink ||
                fromBlik ||
                fromIdeal ||
                fromMBWay) && (
                <PreCheckPoweredBy
                    img={imgObj[paymentForm?.paymentSourceFromMethod]?.img ?? ''}
                    alt={imgObj[paymentForm?.paymentSourceFromMethod]?.alt ?? ''}
                />
            )}
            <FixedBottomPrechequePopUp isRightAligned={false}>
                {props.children}
                {!fromGooglePay && !fromApplePay && !fromPlaid && !fromACH && !fromPayPal && showCVVPopUp && (
                    <Button
                        type="button"
                        raised={true}
                        onClick={onConfirmButtonClick}
                        label={messages.precheckAgreeButton}
                        caption={messages.precheckAgreeButton}
                    />
                )}
                {!fromGooglePay && !fromApplePay && !fromPlaid && !fromACH && !fromPayPal && !showCVVPopUp && (
                    <Button
                        type="button"
                        raised={true}
                        onClick={onConfirmButtonClick}
                        label={messages.precheckAgreeButton}
                        caption={messages.precheckAgreeButton}
                    />
                )}
                {fromACH && (
                    <Button type="link" raised={true} onClick={preConfirm} label={messages.precheckAgreeButton} caption={messages.precheckAgreeButton} />
                )}
                {fromPlaid && (
                    <Button type="link" raised={true} onClick={payAgree} label={messages.precheckAgreeButton} caption={messages.precheckAgreeButton} />
                )}
                {fromGooglePay && <GooglePaySendButton onClick={sendClick} />}
                {fromApplePay && <ApplePayButton onClick={sendClick} />}
                {fromPayPal && (
                    <PayPalButtonWrapper
                        modalRef={props.modalRef}
                        payPalSdkParamsInit={precheck?.payPalSdkParamsInit}
                        precheck={precheck}
                        popupRef={props.popupRef}
                        toggleSpinner={props.toggleSpinner}
                        updateMessages={props.updateMessages}
                        updatePageMessages={props.updatePageMessages}
                        setPaymentParam={setPaymentParam}
                        deliveryMethodId={deliveryMethodId}
                        sourceFundingId={sourceFundingId}
                    />
                )}
            </FixedBottomPrechequePopUp>
        </ComplexPopup>
    );
};

PreCheckPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    formName: PropTypes.string,
    submitRef: PropTypes.shape({ current: PropTypes.object }),
    onOverlayClick: PropTypes.func,
    changePaymentMethod: PropTypes.func,
    paymentMethodState: PropTypes.any,
};
export default connect(null, {
    toggleModal,
    toggleSpinner,
    changeFormFieldValue,
    setNewForm,
    updateMessages,
    updatePageMessages,
})(PreCheckPopup);
